import { Component, Inject, Input, OnInit, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { EquipmentNotesService } from "./equipment-notes.service";
import {
  EquipmentNotesHxVM,
  EquipmentStatusVM,
  SaveEquipmentSummaryNotesModel,
} from "./summary-notes-model";
import { NotificationsService } from "angular2-notifications";
import { EquipmentDetails, EquipmentStatusViewModel } from "../../../modules/manage-equipment/models/manage-equipment.model";
import { ManageEquipmentService } from "../../../modules/manage-equipment/manage-equipment.service";
import { AuditTrailComponent } from "../audit-trail/audit-trail.component";

@Component({
  selector: "app-equipment-notes-history",
  templateUrl: "./equipment-notes-history.component.html",
  styleUrls: ["./equipment-notes-history.component.scss"],
})
export class EquipmentNotesHistoryComponent implements OnInit {
  @ViewChild('auditTrail')
  auditTrail: AuditTrailComponent;

  title: string = "";
  historyTitle: string = "";
  equipmentId: number = 0;
  newComment: string = "";
  commentsHistory: any[] = [];
  summaryNotesExists: boolean = false;
  isEditMode: boolean = false;
  selectedCommentId: number | null = null;
  screenId: number = 0;
  maxCharacters: number = 1000;
  remainingCharacters: number = 1000;
  eqConditionStatusId: number;
  equipmentConditionStatuses: EquipmentStatusViewModel[];
  selectedStatus: EquipmentStatusViewModel;

  constructor(
    private _dialogRef: MatDialogRef<EquipmentNotesHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _service: EquipmentNotesService,
    private notification: NotificationsService,
    private _equipmentService: ManageEquipmentService
  ) {}
  ngOnInit() {
    this.equipmentId = this.data.EquipmentId;
    this.title = this.data.Title;
    this.historyTitle = this.data.HistoryTitle;
    this.summaryNotesExists = this.data.SummaryNotesExists;
    this.screenId = this.data.ScreenId;
    this.eqConditionStatusId = this.data.eqConditionStatusId;
    this.GetEquipmentConditionStatuses();
    if (this.summaryNotesExists) {
      this.getNotesHistory();
    }
  }

  onNoClick(): void {
    this._dialogRef.close({
      refreshSummNotes: this.commentsHistory.length > 0,
      eqConditionStatusId: this.selectedStatus?.Id ?? null,
      summaryNotesExists: this.summaryNotesExists,
    });
  }

  getNotesHistory() {
    this._service.getSummaryNotes(this.equipmentId).subscribe((res) => {
      console.log("Summary Notes History:", res);
      this.commentsHistory = res;
    });
  }

  saveSummaryNotes() {
    let payload: SaveEquipmentSummaryNotesModel = {
      EquipmentId: this.equipmentId,
      SummaryNotes: this.newComment,
      IsActive: false,
      CreatedDate: new Date().toISOString(),
      ModifiedDate: null,
      ScreenId: this.screenId,
    };
    this._service.saveSummaryNotes(payload).subscribe(
      (res: number) => {
        if (res > 0) {
          this.getNotesHistory();
          this.newComment = "";
          this.remainingCharacters = this.maxCharacters;
          this.notification.success("Success", "Comment saved successfully");
        } else {
          this.notification.error("Error", "Failed to save comment");
        }
      },
      (error: any) => {
        console.error("Failed to save comment", error);
        this.notification.error("Error", "Failed to save comment");
      },
    );
  }

  onActiveChange(item: EquipmentNotesHxVM) {
    let payload: EquipmentStatusVM = {
      SummaryNotesId: item.SummaryNotesId,
      Status: item.IsActive,
      SummaryNotes: item.SummaryNotes,
      ModifiedDate: new Date().toISOString(),
      ScreenId: this.screenId,
    };
    this._service.changeNotesStatus(payload).subscribe(
      (res) => {
        if (res) {
          this.getNotesHistory();
          this.notification.success(
            "Success",
            "Summary Notes status updated successfully",
          );
        } else {
          this.notification.error(
            "Error",
            "Failed to update Summary Notes status",
          );
        }
      },
      (error) => {
        console.error("Failed to update Summary Notes status", error);
        this.notification.error(
          "Error",
          "Failed to update Summary Notes status",
        );
      },
    );
  }

  updateSummaryNotes() {
    let payload: EquipmentStatusVM = {
      SummaryNotesId: this.selectedCommentId,

      SummaryNotes: this.newComment,

      Status: true,

      ModifiedDate: new Date().toISOString(),
      ScreenId: this.screenId,
    };

    this._service.editSummaryNotes(payload).subscribe(
      (res) => {
        this.getNotesHistory();

        this.newComment = "";
        this.remainingCharacters = this.maxCharacters;
        this.isEditMode = false;

        this.selectedCommentId = null;
      },
      (error) => {
        console.error("Failed to update comment", error);
      },
    );
  }

  editSummaryNotes(item: any) {
    this.newComment = item.SummaryNotes;
    this.remainingCharacters = this.maxCharacters - this.newComment.length;
    this.isEditMode = true;
    this.selectedCommentId = item.SummaryNotesId;
  }

  resetEditMode() {
    this.newComment = "";
    this.remainingCharacters = this.maxCharacters;

    this.isEditMode = false;

    this.selectedCommentId = null;
  }

  resetCommentText() {
    this.newComment = "";
    this.remainingCharacters = this.maxCharacters;
  }

  onCommentInput() {
    if (!this.newComment) {
      this.remainingCharacters = this.maxCharacters;

      return;
    }

    this.remainingCharacters = this.maxCharacters - this.newComment.length;
  }

  GetEquipmentConditionStatuses() {
    this._equipmentService.GetEquipmentConditionStatuses(this.equipmentId).subscribe(res => {
      this.equipmentConditionStatuses = res || [];
      this.selectedStatus = this.equipmentConditionStatuses.find(
        x => x.Id === this.eqConditionStatusId
      );
    });
  }

  updateEqConditionStaus(status: EquipmentStatusViewModel) {
    this._equipmentService.UpdateEquipmentConditionStatus(this.equipmentId, status.Id).subscribe(res => {
      if (res == true) {
        this.notification.success("Sucessfully update the Equipment Condition Status");
        this.selectedStatus = status;
        this.auditTrail.loadHistory();
      } else {
        this.notification.error("Failed to update the Equipment Condition Status");
      }
    });
  }

  getTextColor(bgColor: string): string {
    if (!bgColor) {
      return '#000000';
    }

    // Remove # if exists
    const color = bgColor.replace('#', '');

    const r = parseInt(color.substring(0, 2), 16);
    const g = parseInt(color.substring(2, 4), 16);
    const b = parseInt(color.substring(4, 6), 16);

    // Calculate brightness
    const brightness = ((r * 299) + (g * 587) + (b * 114)) / 1000;

    // Dark background => white text, light background => black text
    return brightness > 150 ? '#000000' : '#FFFFFF';
  }



}
